import { a as addCommasForCompositeRanges } from "./composites-D0HuUvQk.js";
function renderMarkupBody({
  SVs,
  children
}) {
  if (SVs.hidden) {
    return null;
  }
  if (SVs._compositeReplacementActiveRange) {
    return addCommasForCompositeRanges({
      children,
      compositeReplacementActiveRange: SVs._compositeReplacementActiveRange,
      startInd: 0,
      endInd: children.length - 1
    });
  }
  return children;
}
export {
  renderMarkupBody as r
};
